import { type Client, clientSingleton } from '@edge/spark/io-apollo'
import { filterMaybe } from '@edge/spark/utils'
import { type UserRolesQuery, UserRolesDocument, useUserRolesQuery, type RoleAttributes } from '../generated/graphql'

/** Same as useUserRolesQuery but just the roles without nulls */
export const useRoles = (props?: { skip?: boolean }): RoleAttributes[] => {
    const { skip } = props || {}
    const { data } = useUserRolesQuery({ skip })

    if (skip) {
        return []
    }

    return data?.user?.roles?.filter(filterMaybe) || []
}

interface GetUserRolesProps {
    /** ApolloClient. Attempts to use client singleton if not passed */
    client?: Client
}

/** Same as useUserRolesQuery but just the roles without nulls */
export const getUserRoles = async (props?: GetUserRolesProps) => {
    const client = props?.client || clientSingleton

    const { data } = await client.query<UserRolesQuery>({ query: UserRolesDocument, fetchPolicy: 'network-only' })

    return data?.user?.roles?.filter(filterMaybe) || []
}
